"use client";

import React from "react";
import { useAtomValue } from "jotai";

import { Heading, Paragraph } from "@/components/ui/typography";
import LoginButton from "@/components/login-button";

import { isAuthenticatedAtom } from "@/store/auth";

function Unauthorized() {
  const isAuthenticated = useAtomValue(isAuthenticatedAtom);

  React.useEffect(() => {
    if (isAuthenticated) {
      window.location.reload();
    }
  }, [isAuthenticated]);

  return (
    <div className="flex items-center justify-center py-24 md:py-48 lg:py-68">
      <div className="flex flex-col items-center">
        <Heading variant="h4" className="text-primary">
          Oops! Unauthorized Access
        </Heading>
        <Paragraph>Please login to access this page.</Paragraph>
        <LoginButton className="mt-4" />
      </div>
    </div>
  );
}

export default Unauthorized;
